// extracted by mini-css-extract-plugin
export default {"clone-icon":"ProjectContentCreation_clone-icon__gCVwJ"};